import update from 'immutability-helper';

// ------------------------------------
// Constants
// ------------------------------------
export const SELECT_CATEGORY = 'CATEGORY_FILTER/SELECT_CATEGORY';
export const DESELECT_CATEGORY = 'CATEGORY_FILTER/DESELECT_CATEGORY';
export const CLEAR_SELECTED_CATEGORIES = 'CATEGORY_FILTER/CLEAR_SELECTED_CATEGORIES';
export const SET_SHOW_ALL = 'CATEGORY_FILTER/SET_SHOW_ALL';
// ------------------------------------
// Actions
// ------------------------------------

export function selectCategory(categoryUUID) {
	return {
		type: SELECT_CATEGORY,
		categoryUUID,
	};
}

export function deselectCategory(categoryUUID) {
	return {
		type: DESELECT_CATEGORY,
		categoryUUID,
	};
}

export function clearSelectedCategories() {
	return {
		type: CLEAR_SELECTED_CATEGORIES,
	};
}

export function setShowAll(showAll) {
	return {
		type: SET_SHOW_ALL,
		showAll,
	};
}

// ------------------------------------
// Action Creators
// ------------------------------------

export function toggleShowAll() {
	console.info('CATEGORY_FILTER/TOGGLE_SHOW_ALL');
	return (dispatch, getState) => {
		const toggledShowAll = !getState().categoryFilter.showAll;
		if (getState().categoryFilter.selectedCategories.length === 0) {
			return Promise.resolve();
		}
		if (toggledShowAll) {
			dispatch(clearSelectedCategories());
		}
		return dispatch(setShowAll(toggledShowAll));
	};
}

export function toggleCategorySelect(categoryUUID) {
	console.info('CATEGORY_FILTER/TOGGLE_CATEGORY_SELECT');
	return (dispatch, getState) => {
		if (getState().categoryFilter.selectedCategories.indexOf(categoryUUID) >= 0) {
			if (getState().categoryFilter.selectedCategories.length === 1) {
				return dispatch(toggleShowAll());
			}
			return dispatch(deselectCategory(categoryUUID));
		}
		if (getState().categoryFilter.showAll) {
			dispatch(setShowAll(false));
		}
		return dispatch(selectCategory(categoryUUID));
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SELECT_CATEGORY]: (state, action) => update(state, {
		selectedCategories: { $push: [action.categoryUUID] },
	}),
	[DESELECT_CATEGORY]: (state, action) => update(state, {
		selectedCategories: { $splice: [[state.selectedCategories.indexOf(action.categoryUUID), 1]] },
	}),
	[CLEAR_SELECTED_CATEGORIES]: (state) => update(state, {
		selectedCategories: { $set: [] },
	}),
	[SET_SHOW_ALL]: (state, action) => update(state, {
		showAll: { $set: action.showAll },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
	showAll: true,
	selectedCategories: [],
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
